import React, { useEffect, useState } from 'react'
import { interval } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { Button, Icon } from 'antd'
import moment from 'moment/moment'
import { geolocated } from 'react-geolocated'

function Attendance({
  saveAttendance,
  fetchAttendance,
  attendance,
  coords,
  isGeolocationEnabled,
  isGeolocationAvailable
}) {

  const [attendanceState, setAttendanceState] = useState('')
  const [geoStatus, setGeoStatus] = useState(false)

  useEffect(() => {
    fetchAttendance();
  }, [fetchAttendance]);

  useEffect(() => {
    // console.log(attendance);
    setAttendanceState(attendance && attendance.attendanceType)
  }, [attendance]);

  useEffect(() => {
    const subscription = interval(900000) // 3600000 milliseconds = 1 hour
      .pipe(
        switchMap(() => fetchAttendance())
      )
      .subscribe(
        data => {
          // console.log('Received data:', data);
          // Handle the received data here, e.g., update state
        },
        error => console.error('Error:', error)
      );

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  useEffect(() => {
    handleLocationAlert()
  }, [])

  // Keep geo status in sync with actual availability/permission/coords
  useEffect(() => {
    if (coords && typeof coords.latitude === 'number' && typeof coords.longitude === 'number') {
      setGeoStatus(true)
      return
    }
    if (isGeolocationEnabled === false || isGeolocationAvailable === false) {
      setGeoStatus(false)
      return
    }
    // If still undetermined (e.g., permission prompt pending), don't flip to false prematurely
  }, [coords, isGeolocationEnabled, isGeolocationAvailable])

  const handleLocationAlert = (showMessage = false) => {
    if (isGeolocationEnabled && isGeolocationAvailable) {
      setGeoStatus(true)
    } else {
      setGeoStatus(false)
      if (showMessage) alert("Please enable location services in your browser's settings to use Attendance feature.")
    }
  }

  const handleAttendance = (state) => {
    const now = new Date();
    const { latitude, longitude } = coords || {};
    saveAttendance({
      attendanceDate: moment().format('YYYY-MM-DD'),
      attendanceType: state,
      attendanceTime: now.getHours() * 60 * 60 * 1000 + now.getMinutes() * 60 * 1000 + now.getSeconds() * 1000 + now.getMilliseconds(),
      latitude: latitude || 0,
      longitude: longitude || 0,
    })
  }
  return (
    <>
      {geoStatus ?
        <Button block shape="round" style={{ borderRadius: '25px' }} disabled={!geoStatus}
          type={(!attendanceState || attendanceState === 'OUT') ? 'primary' : 'danger'}
          onClick={() => handleAttendance((!attendanceState || attendanceState === 'OUT') ? 'IN' : 'OUT')}
          icon={(!attendanceState || attendanceState === 'OUT') ? 'login' : 'logout'}>{(!attendanceState || attendanceState === 'OUT') ? 'Check In' : 'Check Out'}</Button>
        : <Button block shape="round" style={{ borderRadius: '25px' }} onClick={() => handleLocationAlert(true)}
          title={'Enable location to get access to Attendance!'}><Icon type="disconnect" /></Button>
      }
    </>
  );
}

export default geolocated({
  positionOptions: {
    enableHighAccuracy: true,
    maximumAge: 15000,
    timeout: 15000
  },
  watchPosition: true,
  userDecisionTimeout: 15000
})(Attendance);
